import { render, staticRenderFns } from "./MyRpType.vue?vue&type=template&id=440159ef"
import script from "./MyRpType.vue?vue&type=script&lang=js"
export * from "./MyRpType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports